/**************************************************************************************************/
/*   File: /src/app/stores/states/editing/state.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 29th 2019                                                         */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon May 13 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DossierId } from '../../../shared/models/dossier.id';
import { Message } from '../../../shared/models/message';
import { DossierStatus } from '../../../shared/models/dossier.status';
import { Dossier, FileModel } from '../../../shared/models';
/**
 * The dossier editing state
 */
export interface EditingState {
  /**
   * The id
   * @type {DossierId}
   */
  dossierId: DossierId;
  /**
   * The dossier detail
   * @type {DossierDetails}
   */
  dossier: Dossier;
  /**
   * The dossier status
   * @type {DossierStatus}
   */
  dossierStatus: DossierStatus;
  /**
   * The messages array
   * @type {Message[]}
   */
  messages: Message[];
  /**
   * Is validating flag
   * @type {boolean}
   */
  isValidating: boolean;
  /**
   * Is validated flage
   * @type {boolean}
   */
  isValidated: boolean;
  /**
   * Is loaded flag
   * @type {boolean}
   */
  isLoaded: boolean;
  /**
   * IsLoading flag
   * @type {boolean}
   */
  isLoading: boolean;
  /**
   * The spatial files
   */
  spatialFiles: Array<FileModel>;
  /**
   * The spatial upload finished
   */
  spatialUploadFinished: boolean;
  /**
  * The other files
  */
  otherFiles: Array<FileModel>;
  /**
   * The other upload finished
   */
  otherUploadFinished: boolean;
  /**
   * The regulations file
   */
  regulationsFiles: {
    [key: string]: {
      originalDoc: {
        files: FileModel[],
        uploadFinished: boolean
      },
      deltaDoc: {
        files: FileModel[],
        uploadFinished: boolean
      },
      finalDoc: {
        files: FileModel[],
        uploadFinished: boolean
      }
    }
  };
  /**
   * Has spatial changes
   */
  hasSpatialChange: boolean;
  /**
   * Has other changes
   */
  hasOtherChange: boolean;
  /**
   * Has regulation changes
   */
  hasRegulationChange: boolean;
  /**
   * Area changed
   */
  regulationAreaChanged?: string;
}

/**
 * The initial dossier editing state
 */
export const INITIAL_DOSSIER_EDITING_STATE: EditingState = {
  dossierId: undefined,
  dossier: undefined,
  dossierStatus: undefined,
  messages: [],
  isValidating: false,
  isValidated: false,
  isLoaded: false,
  isLoading: false,
  spatialFiles: [],
  spatialUploadFinished: false,
  otherFiles: [],
  otherUploadFinished: false,
  regulationsFiles: {},
  hasSpatialChange: false,
  hasOtherChange: false,
  hasRegulationChange: false,
  regulationAreaChanged: undefined
};

/**
 * The state name
 */
export const STATE_NAME = 'editing';